<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="hometiebox">
      <div class="hometieboximg">
        <img src="~assets/images/home/tie1.jpg" alt="" />
      </div>
    </div>　
    <div class="hometiebox2">
      <div class="hometieboximg">
        <img src="~assets/images/home/tieren2.jpg" alt="" />
        <div class="hometiebtnimg">
          <a href="javascript:void(0)" @click="gotoRegTiePage"
            ><img src="~assets/images/home/tiebtn2.png" alt=""
          /></a>
        </div>
      </div>
    </div>　
    <div class="cluebox">
      <div class="cluebg">
        <img src="~assets/images/home/cluebg.jpg" alt="" />
      </div>
      <div class="myclue1" v-show="showClue1">
        <div class="mycluebg">
          <a href="javascript:void(0)" @click="gotoClublist"
            ><img src="~assets/images/home/club-1.jpg" alt=""
          /></a>
        </div>
        <div class="myclue1-click" @mouseover="handleMouseClue1">
          <a href="javascript:void(0)" @click="gotoClublist"
            ><img src="~assets/images/home/clue-1-click.png" alt=""
          /></a>
        </div>
      </div>　
      <div class="myclue2" v-show="showClue2">
        <div class="mycluebg">
          <a href="javascript:void(0)" @click="gotoRacelist">
            <img src="~assets/images/home/club-2.jpg" alt=""
          /></a>
        </div>
        <div class="myclue2-click" @mouseover="handleMouseClue2">
          <a href="javascript:void(0)" @click="gotoClublist"
            ><img src="~assets/images/home/clue-2-click.png" alt=""
          /></a>
        </div>
      </div>
    </div>　
    <div class="racetypebox">
      <div class="racetype1">
        <div class="racetypeone" @mouseover="handleMouseRtype1">
          <img src="~assets/images/home/type1bg.jpg" alt="" />
        </div>
        <div
          class="racetypeone"
          @mouseover="handleMouseRtype1"
          @mouseout="handleMouseoutRtype1"
          v-show="showRtype1"
        >
          <img src="~assets/images/home/type1hover.jpg" alt="" />
        </div>
      </div>　
      <div class="racetype2">
        <div class="racetypeone" @mouseover="handleMouseRtype2">
          <img src="~assets/images/home/type2bg.jpg" alt="" />
        </div>
        <div
          class="racetypeone"
          @mouseover="handleMouseRtype2"
          @mouseout="handleMouseoutRtype2"
          v-show="showRtype2"
        >
          <img src="~assets/images/home/type2hover.jpg" alt="" />
        </div>
      </div>　
      <div class="racetype3">
        <div class="racetypeone" @mouseover="handleMouseRtype3">
          <img src="~assets/images/home/type3bg.jpg" alt="" />
        </div>
        <div
          class="racetypeone"
          @mouseover="handleMouseRtype3"
          @mouseout="handleMouseoutRtype3"
          v-show="showRtype3"
        >
          <img src="~assets/images/home/type3hover.jpg" alt="" />
        </div>
      </div>
    </div>　
    <div class="matchbox">
      <div class="matchbg">
        <img src="~assets/images/home/matchbg2.jpg" alt="" />
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="matchswiper">
        <!-- slides -->
        <swiper-slide>
          <div class="swiperitem">
            <a href="#" @click="gotoRacelist()">
              <img
                src="~assets/images/race/race0.png"
              />
            </a>
          </div>
        </swiper-slide>

        <swiper-slide v-for="item in raceList" :key="item.id">
          <div class="swiperitem">
            <a href="#" @click="gotoRacedetail(item.id)">
              <img
                src="~assets/images/race/raceitem2.jpg"
              />
              <div class="racemask"></div>
              <!-- <img :src="item.raceImage" /> -->
              <p>{{ item.raceName }}</p>
              <p class="countryname">{{ item.countryName }}</p>
            </a>
          </div>
        </swiper-slide>


        <!-- <div class="swiper-pagination" slot="pagination"></div> -->　
        <div class="swiper-scrollbar"   slot="scrollbar"></div>
      </swiper>
    </div>　
    <div class="friendbox">
      <div class="friendbg">
        <img src="~assets/images/home/friendbg.jpg" alt="" />
      </div>
    </div>　
    <div class="posbox">
      <!-- <div class="posbg">
        <img src="~assets/images/home/posbg.jpg" alt="" />
      </div> -->　
      <div class="mypos1" v-show="showpos1">
        <div class="myposbg">
          <img src="~assets/images/home/pos1img.jpg" alt="" />
        </div>
        <div
          class="mypos1-click"
          @mouseover="handleMouseposbtn"
          @mouseout="handleMouseoutPosbtn"
        >
          <img
            src="~assets/images/home/posbtn1.jpg"
            alt=""
            v-show="!showposbtn"
          />
          <img
            class="posbtn2"
            src="~assets/images/home/posbtn2.jpg"
            alt=""
            v-show="showposbtn"
          />
        </div>
      </div>　
      <div class="mypos2" v-show="showpos2">
        <div class="myposbg">
          <img src="~assets/images/home/pos2img.jpg" alt="" />
        </div>
        <div
          class="mypos1-click"
          @mouseover="handleMouseposbtn"
          @mouseout="handleMouseoutPosbtn"
        >
          <img
            src="~assets/images/home/posbtn1.jpg"
            alt=""
            v-show="!showposbtn"
          />
          <img
            class="posbtn2"
            src="~assets/images/home/posbtn2.jpg"
            alt=""
            v-show="showposbtn"
          />
        </div>
      </div>　
      <div class="posline">
        <div class="myposline1" @mouseover="handleMousepos1">
          <img
            src="~assets/images/home/poschoose1.jpg"
            alt=""
            v-show="showpos2"
          />
          <img
            src="~assets/images/home/poschoose2.jpg"
            alt=""
            v-show="showpos1"
          />
        </div>
        <div class="myposline2" @mouseover="handleMousepos2">
          <img
            src="~assets/images/home/poschoose1.jpg"
            alt=""
            v-show="showpos1"
          />
          <img
            src="~assets/images/home/poschoose2.jpg"
            alt=""
            v-show="showpos2"
          />
        </div>
      </div>
    </div>　
    <!-- <WawaList  v-bind:wawadata="wawadata"></WawaList> -->　
    <footerBlock></footerBlock>
  </div>
</template>


<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import WawaList from "./../components/block/wawalist";
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios
import './../assets/less/global.css';
export default {
  name: "Index",
  data() {
    return {
      showClue1: true,
      showClue2: false,
      showRtype1: false,
      showRtype2: false,
      showRtype3: false,
      showposbtn: false,
      showpos1: true,
      showpos2: false,
      msg: "",
      token: "",
      response: null,
      error: null,
      isShowLoginBtn: true,　
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        scrollbar: '.swiper-scrollbar',
        scrollbarHide: false,
        // slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        width : window.innerWidth*0.8,　
        // pagination: '.swiper-pagination',
        slidesPerView: 2.5,
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 60,
        onSlideChangeEnd: (swiper) => {
          //这个位置放swiper的回调方法
          this.page = swiper.realIndex + 1;
          this.index = swiper.realIndex;
        },
      },
      raceList:[]
    };
  },
  components: {
    swiper,
    swiperSlide,
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Home",
      });
    },
    gotoMyPage: function () {
      this.$router.push({
        name: "mypage",
      });
    },
    gotoSetPage: function () {
      this.$router.push({
        name: "Setpage",
      });
    },
    gotoRankPage: function () {
      this.$router.push({
        name: "Rankpage",
      });
    },
    gotoRegTiePage: function () {
      this.$router.push({
        name: "regTiePage",
      });
    },
    gotoClublist: function () {
      this.$router.push({
        name: "clublist",
      });
    },
    gotoRacelist: function () {
      this.$router.push({
        name: "racelist",
      });
    },
     gotoRacedetail: function (id) {
      this.$router.push({
        name: "racedes",
        params: { raceid: id } 
      });
    },
    handleMouseClue1: function () {
      // console.log("handleMouseClue1");
      this.showClue1 = false;
      this.showClue2 = true;
    },
    handleMouseClue2: function () {
      // console.log("handleMouseClue2");
      this.showClue1 = true;
      this.showClue2 = false;
    },
    handleMouseRtype1: function () {
      // console.log("handleMouseRtype1");
      this.showRtype1 = true;
    },
    handleMouseoutRtype1: function () {
      // console.log("handleMouseoutRtype1");
      this.showRtype1 = false;
    },
    handleMouseRtype2: function () {
      // console.log("handleMouseRtype2");
      this.showRtype2 = true;
    },
    handleMouseoutRtype2: function () {
      // console.log("handleMouseoutRtype2");/
      this.showRtype2 = false;
    },
    handleMouseRtype3: function () {
      // console.log("handleMouseRtype3");
      this.showRtype3 = true;
    },
    handleMouseoutRtype3: function () {
      // console.log("handleMouseoutRtype3");
      this.showRtype3 = false;
    },　
    handleMousepos1: function () {
      // console.log("handleMousepos1");
      this.showpos1 = true;
      this.showpos2 = false;
    },　
    handleMouseposbtn: function () {
      // console.log("handleMouseRtype3");
      this.showposbtn = true;
    },
    handleMouseoutPosbtn: function () {
      // console.log("handleMouseoutRtype3");
      this.showposbtn = false;
    },　
    handleMousepos2: function () {
      // console.log("handleMousepos2");
      this.showpos1 = false;
      this.showpos2 = true;
    },　

    async CheckRaceList() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 10,
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/ttRaceInfo/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          this.raceList = this.response.data.data;
          // console.log(this.raceList);

          // this.isShowLoginBtn = false;
        } else {
          // this.isShowLoginBtn = true;
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
    
  },
  mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
    this.token = localStorage.getItem("token");
    // if (this.token) {
    //   this.CheckUserbtn();
    // }
     this.CheckRaceList();
  },
  created() {
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}


.hometiebox {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.hometieboximg {
  width: 100%;
  height: 100%;
}

.hometieboximg img {
  width: 100%;
  height: 100%;
}

.hometiebtnimg {
  position: absolute;
  top: 46.5vw;
  left: 69vw;
  width: 25.5vw;
  height: 5.5vw;
}

.hometiebtnimg img {
  width: 100%;
  height: 100%;
}

.hometiebox2 {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.cluebox {
  width: 100vw;
  height: 70vw;
  position: relative;
}

.cluebg {
  width: 100%;
}

.cluebg img {
  width: 100%;
  height: 100%;
}

.myclue1,
.myclue2 {
  position: absolute;
  top: 18vw;
  left: 3.5vw;
  width: 92vw;
  height: 42vw;
}

.mycluebg img,
.myclue2 img {
  width: 100%;
  height: auto;
}

.myclue1-click {
  position: absolute;
  top: 21vw;
  left: 50vw;
  width: 37vw;
  height: 30vw;
}

.myclue1-click img {
  width: 100%;
  height: auto;
}

.myclue2-click {
  position: absolute;
  top: 21vw;
  left: 3vw;
  width: 37vw;
  height: 30vw;
}

.myclue2-click img {
  width: 100%;
  height: auto;
}

.racetypebox {
  width: 100vw;
  height: 38vw;
  position: relative;
}

.racetype1 {
  position: absolute;
  top: 1vw;
  left: 0vw;
  width: 32vw;
  height: 30vw;
}

.racetypeone {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.racetypeone img {
  width: 100%;
  height: auto;
}

.racetype2 {
  position: absolute;
  top: 1vw;
  left: 33vw;
  width: 32vw;
  height: 30vw;
}

.racetype3 {
  position: absolute;
  top: 1vw;
  left: 66.2vw;
  width: 32vw;
  height: 30vw;
}

.matchbox {
  width: 100vw;
  height: 55vw;
  position: relative;
}

.matchbg {
  width: 99vw;
  left: 0vw;
  position: relative;
}

.matchbg img {
  width: 100%;
  height: auto;
}
.matchswiper{
  position: absolute;
  top: 12vw;
  left: 0;
  width: 100%;
  height: 43vw;
}

.swiperitem{
  width: 30vw;
  height: 40vw;
  overflow: hidden; /* 超出部分隐藏 */
}
.swiperitem img{
  width: auto; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
}
.swiperitem p{
  position: absolute;
  top: 28vw;
  left: 3vw;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 3vw;
}
.racemask{
  position: absolute;
  top: 0;
  left: 0;
  width: 30vw;
  height: 40vw;
  background-color: rgba(168, 31, 36, 0.5);
}

.swiperitem .countryname{
  position: absolute;
  top: 32vw;
  left: 3vw;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 1.5vw;
}

.swiper-scrollbar{
  background: #fff;
  width:80vw;
  left: 10vw;
  height: 0.5vw;
}


.swiper-scrollbar-drag  {
  background: #a81f24;
}


.friendbox {
  width: 100vw;
  height: 47vw;
  position: relative;
}

.friendbg {
  width: 99vw;
  left: 0vw;
  position: relative;
}

.friendbg img {
  width: 100%;
  height: auto;
}

.posbox {
  width: 100vw;
  height: 70vw;
  position: relative;
}

.myposbg {
  width: 100%;
  height: 100%;
}

.myposbg img {
  width: 100%;
  height: auto;
}

.mypos1-click {
  position: absolute;
  top: 51vw;
  left: 54vw;
  width: 15vw;
  height: 3vw;
}

.mypos1-click img {
  width: 100%;
  height: auto;
}

.mypos1-click .posbtn2 {
  width: 38vw;
  height: auto;
}

.posline {
  position: absolute;
  top: 64vw;
  left: 14vw;
  width: 80vw;
  height: 3vw;
}

.myposline1 {
  position: absolute;
  top: 0vw;
  left: 15vw;
  width: 20vw;
  height: 3vw;
}

.myposline2 {
  position: absolute;
  top: 0vw;
  left: 37vw;
  width: 20vw;
  height: 3vw;
}

.myposline1 img,
.myposline2 img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue